import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));


export default function CustomDrawerHeader(props) {
    const { children } = props;
    return (
        <DrawerHeader>
            {children}
        </DrawerHeader>
    );
}